import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { MenuService } from '@services/menu.service';
import Swal from 'sweetalert2';
import { CanComponentDeactivate } from './can-component-deactivate-guard.service';

@Injectable({ providedIn: 'root' })
export class CanImportDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
  constructor(private readonly menu: MenuService) {}

  public async canDeactivate(
    component: CanComponentDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ) {
    const res = await (component.canDeactivate ? component.canDeactivate() : true);
    if (res) {
      return true;
    }
    return false;
  }

  public async canDeactivatePopupTab(): Promise<boolean> {
    const promise: Promise<boolean> = new Promise<boolean>((resolve, reject) => {
      Swal.fire({
        title: 'Import in Progress!',
        text: 'You have an import in Progress. Please click Cancel to return to the page or Continue to cancel import.  ',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Cancel Import',
        cancelButtonText: 'Continue Import',
        reverseButtons: true,
        allowEscapeKey: true
      })
        .then(result => {
          if (result && result.value) {
            resolve(true);
          } else {
            resolve(false);
          }
        })
        .catch(err => {
          reject(true);
        });
    });

    return promise;
  }
}
